import { render } from "./ProviderPricesModal.vue?vue&type=template&id=553e74ba"
import script from "./ProviderPricesModal.vue?vue&type=script&lang=js"
export * from "./ProviderPricesModal.vue?vue&type=script&lang=js"

import "./ProviderPricesModal.vue?vue&type=style&index=0&id=553e74ba&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__